
import { getFacility } from './facility';
import { saveAssessment } from "./assessments";
import { getAssessmentType } from "./assessmentTypes";

import { newSectionA, saveSectionA } from './sectiona';
import { newSectionB, saveSectionB } from './sectionb';
//import { newSectionC, saveSectionC } from "./sectionc";

import {workdayTimeRanges } from "../utils/datetime";

/*
Helps clear section b if we run into an issue with schema applicaiton
--delete from section_b where assessment_id not in (select id from assessments);

*/

const startNewAssessment = async ({started_on, animal_id, facility_id, user_id, is_online, override_section_a_observations_total, override_section_b_observations_total, start_of_day, end_of_day, assessment_type_id, assessment_title, is_visibile_in_reports = true}) => {
    console.log("start new assessment");


    const facility = await getFacility();


    const assessmentType = assessment_type_id ? await getAssessmentType(assessment_type_id) : null;

    // adjust the totals for section a and b observations
    const section_a_total = override_section_a_observations_total || assessmentType?.section_a_observations_total || facility.section_a_observations_total || 4;
    const section_b_total = override_section_b_observations_total || assessmentType?.section_b_observations_total || facility.section_b_observations_total || 4;


    const startOfDay = start_of_day || facility.start_of_day;
    const endOfDay = end_of_day || facility.end_of_day;

    if (!startOfDay || !endOfDay) {
        throw new Error("Workday timeframe is not configured for this assessment");
    }

    // save the assessment, get the ID
    const assessmentSaveResults = await saveAssessment({
        started_on,
        animal_id,
        start_of_day: startOfDay,
        end_of_day: endOfDay,
        assessment_type_id: assessment_type_id || null,
        assessment_title: assessment_title || null,
        is_visibile_in_reports: is_visibile_in_reports !== false,
        section_a_timer_seconds: assessmentType?.section_a_timer_seconds || null,
        section_b_timer_seconds: assessmentType?.section_b_timer_seconds || null,
    }, facility_id, user_id, is_online);

    console.log('assessment save results', assessmentSaveResults);

    const assessment_id = assessmentSaveResults.id;



    // set up and save the number of section As
    const workdayRanges = workdayTimeRanges(startOfDay, endOfDay);

    let sectionARanges = workdayRanges;
    console.log(sectionARanges);

    let sectionARangesOrder = 0;
    const sectionAPromises = sectionARanges.map(async (cur)=>{
        const payload = {
            ...newSectionA(),
            //observed_on: today(), 
            observation_range: cur,
            assessment_id,
            user_id,
            sort_order: sectionARangesOrder,
        };
        sectionARangesOrder++;
        return await saveSectionA(payload,is_online);
    });

    if (facility.section_a_observations_total > 4) {
        for (let i = 0; i < section_a_total - 4; i++) {

            const rangeText = "Extra Observation " + (i + 1).toString();

            const payload = {
                ...newSectionA(),
                observation_range: rangeText,
                assessment_id,
                user_id,
                sort_order: sectionARangesOrder,
            };
            sectionARangesOrder++;
            sectionAPromises.push(saveSectionA(payload,is_online));
        }
    }

    const sectionASaveresults = await Promise.all(sectionAPromises);
    console.log('assessment save sectiona',sectionASaveresults);


    // generate observation ranges
    //const days = ["Day 1","Day 2","Day 3"];
    const days = ["Day 1"];
    //const workdayRanges = workdayTimeRanges(facility.start_of_day, facility.end_of_day);

    const sectionBRanges = days.reduce((acc,day)=>{
        const temp = workdayRanges.map((cur)=>{
            return day + ": " + cur;
        });
        return acc.concat(temp);
    },[]);

    console.log(sectionBRanges);

    let sectionBRangesOrder = 0;

    const sectionBPromises = sectionBRanges.map(async (cur)=>{
        const payload = {
            ...newSectionB(),
            //observed_on: today(), 
            observation_range: cur,
            assessment_id,
            user_id,
            sort_order: sectionBRangesOrder
        };
        sectionBRangesOrder++;
        return await saveSectionB(payload,is_online);
    });


    if (facility.section_b_observations_total > 4) {
        for (let i = 0; i < section_b_total - 4; i++) {

            const rangeText = "Extra Observation " + (i + 1).toString();

            const payload = {
                ...newSectionB(),
                observation_range: rangeText,
                assessment_id,
                user_id,
                sort_order: sectionBRangesOrder
            };
            sectionBRangesOrder++;
            sectionBPromises.push(saveSectionB(payload,is_online));
        }
    }

    const sectionBSaveresults = await Promise.all(sectionBPromises);
    console.log('assessment save sectionb',sectionBSaveresults);


    /*
    const sectionCRanges = halfHourTimeSlots(endOfDay, startOfDay);
    let sectionCRangesOrder = 0;

    const sectionCPromises = sectionCRanges.map(async (cur)=>{
        const payload = {
            ...newSectionC(),
            //observed_on: today(), 
            observation_range: cur, 
            assessment_id, 
            user_id,
            sort_order: sectionCRangesOrder,
        };
        sectionCRangesOrder++;
        return await saveSectionC(payload,is_online);
    });

    const sectionCSaveresults = await Promise.all(sectionCPromises);
    console.log('assessment save sectionc',sectionCSaveresults);
    */

    return true
}


export {startNewAssessment};
